module.exports = __webpack_public_path__ + "static/media/freelo.9e4653d2.png";